import * as React from "react";
const SvgFiRrCheapBill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3m0 4.25c-.689 0-1.25-.561-1.25-1.25s.561-1.25 1.25-1.25 1.25.561 1.25 1.25-.561 1.25-1.25 1.25M17.5 0h-11A4.505 4.505 0 0 0 2 4.5v5C2 11.981 4.019 14 6.5 14H11v7.366l-2.293-2.293a.999.999 0 1 0-1.414 1.414l2.636 2.636a2.98 2.98 0 0 0 2.121.876c.803 0 1.556-.312 2.121-.876l2.536-2.535a.999.999 0 1 0-1.414-1.414L13 21.467V14h4.5c2.481 0 4.5-2.019 4.5-4.5v-5C22 2.019 19.981 0 17.5 0M20 9.5c0 1.378-1.122 2.5-2.5 2.5h-11A2.503 2.503 0 0 1 4 9.5v-5C4 3.122 5.122 2 6.5 2h11C18.878 2 20 3.122 20 4.5zm-12 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 8 9.5m0-5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 8 4.5m11 5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 19 9.5m0-5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 19 4.5"
    />
  </svg>
);
export default SvgFiRrCheapBill;
